import Vue from "vue";
import Vuex from "vuex";
import auth from "@/store/modules/auth";
import cart from "@/store/modules/cart";
import project_store from "@/store/modules/project_store";
import submission_clipboard from "@/store/modules/submission_clipboard";
//import project from '@/store/modules/project';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    cart,
    submission_clipboard,
    project_store
    //project
  }
});
